import { PageContainer } from 'app/layout';

export const NotFound = () => {
  return <PageContainer title="Not Found">This page could not be found</PageContainer>;
};

export default NotFound;
